
import { mapMutations, mapState, mapActions } from 'vuex';

import AccountBody from '@/components/account/AccountBody.vue';

export default {
  name: 'AccountPage',
  components: {
    AccountBody
  },
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    let account = await $utils.content('account')
    let sections = account?.content?.sections || []
    let sectionFound = sections.find(s => s.component === 'account-config')
    let accountConfig = sectionFound ? sectionFound : null
    return {
      story: account,
      accountConfig: accountConfig.sections
    }
  },
  data() {
    return {
      config: {
        provider: 'olo',
        placement: 'account',
        header: 'Account',
        welcome_message: 'Welcome Back,',
        // menu: [],
        menu: [
          {
            name: 'Personal Information', // Used in acconut nav component to display section names, can be changed across projects
            section: 'user-info', // Used to conditionally show account views, should not be changed across projects
            icon: 'location-icon',
            active_class: 'icon white',
            default_class: 'icon black'
          },
          {
            name: 'Order History',
            section: 'order-history',
            icon: 'location-icon',
            active_class: 'icon white',
            default_class: 'icon black'
          },
          {
            name: 'Payment Methods',
            section: 'payments',
            icon: 'location-icon',
            active_class: 'icon white',
            default_class: 'icon black'
          },
          {
            name: 'Available Offers',
            section: 'offers',
            icon: 'location-icon',
            active_class: 'icon white',
            default_class: 'icon black'
          },
          {
            name: 'Rewards',
            section: 'rewards',
            icon: 'rewards-icon',
            active_class: 'icon white',
            default_class: 'icon black'
          },
          {
            name: 'Locations',
            section: 'locations',
            icon: 'location-icon',
            active_class: 'icon white',
            default_class: 'icon black'
          },
        ],
        fields: {
          info: [
            {
              name: 'email',
              label: 'Email Address',
              placeholder: 'Email Address',
              type: 'email',
              required: true,
              valid: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              errors: {
                invalid: 'Please enter a valid email address.'
              }
            },
            {
              name: 'first_name',
              label: 'First Name',
              placeholder: 'First Name',
              autocomplete: 'firstName',
              type: 'text',
              required: true,
              valid: /^[A-Za-z\s]*$/,
              errors: {
                invalid: 'Names may only contain letters'
              }
            },
            {
              name: 'last_name',
              label: 'Last Name',
              placeholder: 'Last Name',
              autocomplete: 'lastName',
              type: 'text',
              required: true,
              valid: /^[A-Za-z\s]*$/,
              errors: {
                invalid: 'Names may only contain letters'
              }
            },
            {
              name: 'phone',
              label: 'Phone Number',
              placeholder: 'Phone Number',
              autocomplete: 'phoneNumber',
              type: 'text',
              mask: '###-###-####',
              required: false,
              valid: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
              errors: {
                invalid: 'Please enter a valid US phone number'
              }
            },
            {
              name: 'dob',
              label: 'Date of Birth',
              type: 'date-select',
              valid: /^\d{4}-\d{2}-\d{2}$/,
              required: false,
              errors: {
                invalid: 'Please enter a valid Date of Birth'
              }
            },
            {
              name: 'optin',
              label: 'Receive email messages',
              message: 'Yes, send me email updates about my rewards and special offers.',
              type: 'checkbox',
              showTerms: false,
              required: false,
              errors: {
                invalid: 'Email opt in must be selected.'
              }
            },
            {
              name: 'optin_sms',
              label: 'Receive text messages',
              message: 'Yes, send me Text Messages about my rewards and special offers. Msg/Data rates may apply. Reoccurring messages may be sent by an automated system. Consent not required. Text ‘Help’ for help, text ‘Stop’ to end anytime.',
              type: 'checkbox',
              showTerms: true,
              required: false,
              errors: {
                invalid: 'SMS opt in must be selected.'
              }
            }
          ]
        }
      },
    }
  },
  computed: {
    ...mapState([ 'token', 'user' ])
  },
  methods: {
    ...mapMutations(['setHowToRedeem']),
    ...mapActions({
      getOffers: 'members/getOffers',
      getPayments: 'members/getPayments',
      getRewards: 'members/getRewards',
      getBadges: 'members/getBadges',
    }),
  },
  async beforeMount() {
    this.config.menu = this.accountConfig;
    const howToRedeem = this.story.content.sections.filter(section => section.component === 'how_to_redeem')[0]
    if(howToRedeem) {
      this.setHowToRedeem(howToRedeem);
    }
    if (this.user) {
      await Promise.all([
        this.getOffers(),
        this.getRewards(),
        this.getPayments(),
        this.getBadges(),
      ])
    }
  }
}
